export const lazyFormatPhoneNumber = (phoneNumber: string): Promise<string> =>
  import(
    /* webpackChunkName: "libphonenumber-js" */
    "libphonenumber-js"
  ).then((Module) => {
    const parsedPhoneNumber = Module.parsePhoneNumber(phoneNumber);

    return parsedPhoneNumber.country === "US"
      ? parsedPhoneNumber.formatNational()
      : parsedPhoneNumber.formatInternational();
  });
